import { IUser } from 'src/interfaces/user';
import {
    DEVELOPER_LEVEL_ACCESS,
    USER_LEVEL_ACCESS,
} from 'src/components/access';
import { BOTH_AREA } from 'src/constants/store/areas';
import { IStore } from 'src/interfaces/store';
import { DATE_RANGES } from 'src/views/charts/constants/timeRanges';
import { TFilters } from '../components/types';
import { cleanObject } from './cleanObject';

/**
 * Format information as developer
 *
 * @param {TFilters} currents
 * @return {*}
 */
export const formatInformation = (currents: TFilters, user: IUser) => {
    const isDeveloper = user?.accessLevel === DEVELOPER_LEVEL_ACCESS;
    const isUser = user?.accessLevel === USER_LEVEL_ACCESS;

    let currentCreatedAt = {
        gte: currents.startDate || '',
        lte: currents.endDate || '',
    };

    if (isDeveloper) {
        let response = {
            carType: currents.carType,
            type: currents.type,
            store: currents.store,
            createdAt: currentCreatedAt,
            source: currents.source,
            from: currents.from,
            agent: currents.agent,
        };

        return cleanObject(response);
    } else {
        const initialArea = user?.areas || null;
        const initialCarType =
            user?.carType === BOTH_AREA ? null : user?.carType;
        const initialStore = user?.stores.map((store: IStore) => store._id);
        const initialAgent = isUser ? user?._id : null;
        const initialSource = null;
        const initialFrom = null;

        let response = {
            carType:
                currents.carType.length > 0 ? currents.carType : initialCarType,
            type: currents.type.length > 0 ? currents.type : initialArea,
            store: currents.store.length > 0 ? currents.store : initialStore,
            createdAt: currentCreatedAt,
            agent: currents.agent.length > 0 ? currents.agent : initialAgent,
            source:
                currents.source.length > 0 ? currents.source : initialSource,
            from: Array.isArray(currents.from) && currents.from.length > 0
                ? currents.from
                : initialFrom,
        };
        return cleanObject(response);
    }
};
